import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MenuSubMenuHeaderConfigurationService } from '@service/header-configuration/menu-sub-menu-header-configuration.service';
import { detectBrowserName } from '../utils/browser-name.utils';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private readonly menuSubMenuHeaderConfigurationService: MenuSubMenuHeaderConfigurationService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.getPublicIP()).pipe(
      switchMap((ip) => {
        const menuInfo =
          this.menuSubMenuHeaderConfigurationService.getMenuInfo();

        const clonedRequest = req.clone({
          setHeaders: {
            'user-ip': ip,
            'menu-id': menuInfo.menuId,
            'menu-name': menuInfo.menuName,
            'submenu-id': menuInfo.subMenuId,
            'submenu-name': menuInfo.subMenuName,
            'web-browser-name': detectBrowserName(navigator.userAgent),
          },
        });
        return next.handle(clonedRequest);
      })
    );
  }

  async getPublicIP(): Promise<string> {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Error fetching public IP:', error);
      return '';
    }
  }
}
